/* =================================================================
   ATTIC DOOR MEDIA — theme.js
   Vanilla JS. No dependencies.
   ================================================================= */
(function () {
  "use strict";

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) =>
    (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.themeMoneyFormat)
      : "$" + (cents / 100).toFixed(2);

  /* ---------- Drawer helpers ---------- */
  const overlay = $("#overlay");
  function openDrawer(el) {
    if (!el) return;
    el.classList.add("is-open");
    overlay && overlay.classList.add("is-active");
    document.documentElement.style.overflow = "hidden";
  }
  function closeAllDrawers() {
    $$(".cart-drawer, .mobile-nav").forEach((d) => d.classList.remove("is-open"));
    overlay && overlay.classList.remove("is-active");
    document.documentElement.style.overflow = "";
  }
  overlay && overlay.addEventListener("click", closeAllDrawers);
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeAllDrawers(); });

  /* ---------- Mobile nav ---------- */
  const mobileNav = $("#mobile-nav");
  $("#burger") && $("#burger").addEventListener("click", () => openDrawer(mobileNav));
  $$("[data-close-nav]").forEach((b) => b.addEventListener("click", closeAllDrawers));

  /* ---------- Mobile submenu accordions ---------- */
  $$(".mobile-nav__toggle").forEach((btn) => {
    btn.addEventListener("click", () => {
      const group = btn.closest(".mobile-nav__group");
      const sub = group && group.querySelector(".mobile-nav__sub");
      const open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!open));
      if (sub) sub.hidden = open;
    });
  });

  /* ---------- Header dropdowns (touch / no-hover) ---------- */
  const noHover = window.matchMedia && window.matchMedia("(hover: none)").matches;
  const dropdownItems = $$(".header-nav__item.has-dropdown");
  function closeDropdowns(except) {
    dropdownItems.forEach((item) => {
      if (item === except) return;
      item.classList.remove("is-open");
      const t = item.querySelector(".header-nav__link--parent");
      t && t.setAttribute("aria-expanded", "false");
    });
  }
  dropdownItems.forEach((item) => {
    const trigger = item.querySelector(".header-nav__link--parent");
    if (!trigger) return;
    trigger.addEventListener("click", (e) => {
      if (!noHover) return; // pointer devices use hover/focus
      e.preventDefault();
      const isOpen = !item.classList.contains("is-open");
      closeDropdowns(item);
      item.classList.toggle("is-open", isOpen);
      trigger.setAttribute("aria-expanded", String(isOpen));
    });
  });
  if (dropdownItems.length) {
    document.addEventListener("click", (e) => {
      if (e.target.closest(".header-nav__item.has-dropdown")) return;
      closeDropdowns(null);
    });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeDropdowns(null); });
  }

  /* ---------- Cart drawer ---------- */
  const cartDrawer = $("#cart-drawer");

  $$("[data-cart-open]").forEach((b) =>
    b.addEventListener("click", (e) => {
      if (cartDrawer) { e.preventDefault(); refreshCart().then(() => openDrawer(cartDrawer)); }
    })
  );
  $$("[data-close-cart]").forEach((b) => b.addEventListener("click", closeAllDrawers));

  function renderCart(cart) {
    const itemsEl = $("#cart-items");
    const countEls = $$(".cart-count");
    const subtotalEl = $("#cart-subtotal");
    if (countEls.length) {
      countEls.forEach((c) => {
        c.textContent = cart.item_count;
        c.hidden = cart.item_count === 0;
      });
    }
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="cart-empty"><div class="glyph">✦</div><p>Your satchel is empty.</p><a class="btn btn--ghost" href="/collections/all">Browse the wares</a></div>';
      const foot = $("#cart-foot"); if (foot) foot.hidden = true;
      return;
    }
    const foot = $("#cart-foot"); if (foot) foot.hidden = false;

    itemsEl.innerHTML = cart.items
      .map((item, i) => {
        const img = item.image
          ? `<div class="cart-line__img"><img src="${item.image.replace(/(\.[a-z]+)(\?.*)?$/i, "_120x$1$2")}" alt="${item.product_title}" width="64" height="80"></div>`
          : '<div class="cart-line__img"></div>';
        const variant =
          item.variant_title && item.variant_title !== "Default Title"
            ? `<div class="cart-line__variant">${item.variant_title}</div>`
            : "";
        return `<div class="cart-line" data-line="${i + 1}">
          ${img}
          <div>
            <a class="cart-line__title" href="${item.url}">${item.product_title}</a>
            ${variant}
            <div class="qty" style="margin-top:.6rem">
              <button type="button" data-qty-change="${i + 1}" data-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
              <input type="text" value="${item.quantity}" readonly aria-label="Quantity">
              <button type="button" data-qty-change="${i + 1}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
            </div>
          </div>
          <div style="text-align:right">
            <div class="price">${money(item.final_line_price)}</div>
            <button type="button" class="link-arrow" style="margin-top:.6rem;font-size:.66rem" data-qty-change="${i + 1}" data-qty="0">Remove</button>
          </div>
        </div>`;
      })
      .join("");

    $$("[data-qty-change]", itemsEl).forEach((btn) =>
      btn.addEventListener("click", () =>
        changeLine(parseInt(btn.dataset.qtyChange, 10), parseInt(btn.dataset.qty, 10))
      )
    );
  }

  function refreshCart() {
    return fetch("/cart.js", { headers: { "Content-Type": "application/json" } })
      .then((r) => r.json())
      .then((cart) => { renderCart(cart); return cart; });
  }

  function changeLine(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line, quantity }),
    })
      .then((r) => r.json())
      .then((cart) => renderCart(cart));
  }

  /* ---------- Add to cart (AJAX) ---------- */
  $$("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", (e) => {
      if (!cartDrawer) return; // fall back to native /cart
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
      fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
        .then((r) => r.json())
        .then(() => refreshCart())
        .then(() => { openDrawer(cartDrawer); })
        .catch(() => { form.submit(); })
        .finally(() => { if (btn) { btn.disabled = false; btn.textContent = original; } });
    });
  });

  // Initialize cart count on load
  refreshCart();

  /* ---------- Accordions ---------- */
  $$(".accordion__btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const item = btn.closest(".accordion__item");
      const panel = item.querySelector(".accordion__panel");
      const open = item.classList.toggle("is-open");
      if (open && panel.hasAttribute("data-auto-height")) {
        // Lazy-loaded/expanding content (e.g. reviews widget) — don't clip it
        panel.style.maxHeight = "none";
      } else {
        panel.style.maxHeight = open ? panel.scrollHeight + "px" : 0;
      }
    });
  });

  // Open the Reviews accordion when a rating link or #reviews hash is used
  function openAccordionItem(id) {
    const item = document.getElementById(id);
    if (item && !item.classList.contains("is-open")) {
      const b = item.querySelector(".accordion__btn");
      if (b) b.click();
    }
  }
  $$('a[href="#reviews"]').forEach((a) =>
    a.addEventListener("click", () => setTimeout(function () { openAccordionItem("reviews"); }, 60))
  );
  if (location.hash === "#reviews") setTimeout(function () { openAccordionItem("reviews"); }, 300);

  /* ---------- PDP variant + gallery ---------- */
  $$("[data-pdp]").forEach((root) => {
    const data = root.querySelector("[data-variants-json]");
    if (!data) return;
    let variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    const optionInputs = $$("[data-option-index]", root);
    const idField = root.querySelector("[data-variant-id]");
    const priceEl = root.querySelector("[data-price]");
    const addBtn = root.querySelector("[data-add-btn]");
    const mainImg = root.querySelector("[data-main-img]");
    const thumbs = $$("[data-thumb]", root);

    function showImage(thumb) {
      if (!thumb) return;
      thumbs.forEach((x) => x.classList.remove("is-active"));
      thumb.classList.add("is-active");
      if (mainImg) { mainImg.src = thumb.dataset.full; mainImg.srcset = ""; }
    }

    function findVariant() {
      const chosen = {};
      $$(".swatch.is-active[data-option-index]", root).forEach((s) => {
        chosen[s.dataset.optionIndex] = s.dataset.value;
      });
      return variants.find((v) =>
        Object.keys(chosen).every((idx) => v["option" + (parseInt(idx, 10) + 1)] === chosen[idx])
      );
    }
    function update() {
      const v = findVariant();
      if (!v) return;
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.dataset.add || "Add to satchel" : "Sold out";
      }
      // Swap the main image to the selected variant's image, if it has one
      if (v.featured_image && v.featured_image.id) {
        const match = thumbs.find((t) => String(t.dataset.imageId) === String(v.featured_image.id));
        if (match) showImage(match);
      }
    }
    optionInputs.forEach((sw) =>
      sw.addEventListener("click", () => {
        $$(`.swatch[data-option-index="${sw.dataset.optionIndex}"]`, root).forEach((s) =>
          s.classList.remove("is-active")
        );
        sw.classList.add("is-active");
        update();
      })
    );
    update();

    // Gallery thumbs
    thumbs.forEach((t) => t.addEventListener("click", () => showImage(t)));
  });

  /* ---------- Quantity selectors (generic) ---------- */
  $$("[data-qty-wrap]").forEach((wrap) => {
    const input = wrap.querySelector("input");
    wrap.querySelectorAll("button").forEach((b) =>
      b.addEventListener("click", () => {
        const step = b.dataset.step === "down" ? -1 : 1;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      })
    );
  });

  /* ---------- World carousel ---------- */
  $$("[data-world-carousel]").forEach((root) => {
    const track = root.querySelector("[data-track]");
    const slides = track ? Array.from(track.children) : [];
    if (!track || slides.length <= 1) return;

    const dots = $$("[data-dot]", root);
    const prevBtn = root.querySelector("[data-prev]");
    const nextBtn = root.querySelector("[data-next]");
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let index = 0;
    let timer = null;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = "translateX(-" + index * 100 + "%)";
      dots.forEach((d, k) => d.classList.toggle("is-active", k === index));
      slides.forEach((s, k) => { try { s.inert = k !== index; } catch (e) {} });
    }

    const autoSecs = parseInt(root.dataset.autoplay || "0", 10);
    function start() { if (autoSecs > 0 && !reduce) timer = setInterval(() => go(index + 1), autoSecs * 1000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    if (prevBtn) prevBtn.addEventListener("click", () => { go(index - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener("click", () => { go(index + 1); restart(); });
    dots.forEach((d) => d.addEventListener("click", () => { go(parseInt(d.dataset.dot, 10)); restart(); }));

    // Swipe / drag
    let x0 = null;
    root.addEventListener("pointerdown", (e) => { x0 = e.clientX; });
    root.addEventListener("pointerup", (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); restart(); }
      x0 = null;
    });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);

    go(0);
    start();
  });

  /* ---------- Lightbox ---------- */
  const lightbox = $("#lightbox");
  if (lightbox) {
    const lbImg = $(".lightbox__img", lightbox);
    const openLightbox = (src, alt) => {
      if (!src || !lbImg) return;
      lbImg.src = src;
      lbImg.alt = alt || "";
      lightbox.classList.add("is-open");
      lightbox.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
    };
    const closeLightbox = () => {
      lightbox.classList.remove("is-open");
      lightbox.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      if (lbImg) lbImg.src = "";
    };
    $$("[data-lightbox]").forEach((el) =>
      el.addEventListener("click", () => {
        const img = el.querySelector("img");
        openLightbox(el.dataset.full, img ? img.alt : "");
      })
    );
    lightbox.addEventListener("click", (e) => {
      if (e.target === lightbox || e.target.closest(".lightbox__close")) closeLightbox();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && lightbox.classList.contains("is-open")) closeLightbox();
    });
  }

  /* ---------- Scroll reveal ---------- */
  const reveals = $$("[data-reveal]");
  if ("IntersectionObserver" in window && reveals.length) {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); }
      }),
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add("is-visible"));
  }
})();
